<template>
  <el-container>
    <el-header class="header">
        <div class="container">
          <router-link :to="{name: 'Index'}" tag="h1">CIP 管理ページ</router-link>
          <slot name="header"></slot>
          <ul class="nav">
            <li class="nav-item">
              <el-dropdown @command="handleCommand">
                <span><i class="el-icon-more"></i></span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="logout">ログアウト</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </li>
          </ul>
        </div>
    </el-header>
    <el-container>
      <el-aside width="200px">
        <el-menu :router="true">
          <el-menu-item index="Analytics" :route="{name: 'Analytics'}">
            次回来店状況
          </el-menu-item>
          <el-menu-item index="AnalyticsCustomerStatus" :route="{name: 'AnalyticsCustomerStatus'}">
            会員ステータス
          </el-menu-item>
          <el-menu-item index="AnalyticsDaily" :route="{name: 'AnalyticsDaily'}">
            日報
          </el-menu-item>
          <el-menu-item index="AnalyticsDailyList" :route="{name: 'AnalyticsDailyList'}">
            日報一覧
          </el-menu-item>
          <el-menu-item index="CsvExport" :route="{name: 'CsvExport'}">
            csv出力
          </el-menu-item>
        </el-menu>
      </el-aside>
      <el-container>
        <el-main>
          <router-view/>
        </el-main>
      </el-container>
    </el-container>
  </el-container>
</template>

<script>
import {mapActions} from 'vuex'

export default {
  name: 'AdminLayout',
  methods: {
    ...mapActions(['logout']),
    handleCommand (command) {
      switch (command) {
        case 'logout':
          this.doLogout()
          break
        default:
          break
      }
    },
    doLogout () {
      this.logout()
      this.$router.push({name: 'Login'})
    },
  },
}
</script>

<style scoped>
.header h1 {
  float: left;
  margin: 0;
  padding-left: 20px;
  font-size: 32px;
  font-weight: 400;
  line-height: 60px;
  -webkit-margin-start: 0px;
}

.header .nav {
  float: right;
  height: 100%;
  line-height: 60px;
  background: transparent;
  padding: 0;
  margin: 0;
  padding-right: 20px;
}

.header .nav-item {
  margin: 0;
  float: left;
  list-style: none;
  position: relative;
  cursor: pointer;
}

.el-header, .el-footer {
  background-color: #B3C0D1;
  color: #333;
  text-align: center;
  line-height: 60px;
}

.el-aside {
  background-color: #D3DCE6;
  color: #333;
  text-align: center;
  line-height: 200px;
}

.el-main {
  background-color: #E9EEF3;
  color: #333;
}

body > .el-container {
  margin-bottom: 40px;
}

.el-container:nth-child(5) .el-aside,
.el-container:nth-child(6) .el-aside {
  line-height: 260px;
}

.el-container:nth-child(7) .el-aside {
  line-height: 320px;
}
</style>



// WEBPACK FOOTER //
// src/components/Layout/Admin.vue